import React, { useMemo } from 'react';
import { STRINGS, formatCurrency, formatNumber } from '../utils/constants';

const KPICard = ({ variant, title, icon, value, suffix, footer }) => (
  <div className={`glass-card kpi-card ${variant}`}>
    <div className="kpi-header">
      <span className="kpi-title">{title}</span>
      <div className="kpi-icon-wrapper"><i className={`fa ${icon}`} /></div>
    </div>
    <div className="kpi-body">
      <div className="kpi-value">
        {value}
        {suffix ? <span style={{ fontSize: '1rem', marginInlineStart: '4px' }}>{suffix}</span> : null}
      </div>
      {footer ? <div className="kpi-trend trend-neutral">{footer}</div> : null}
    </div>
  </div>
);

// All KPIs derive from `data` — no hardcoded percentages or growth deltas.
const KPIGrid = ({ data }) => {
  const cards = useMemo(() => {
    if (!data) return [];

    const list = [
      {
        key: 'reservations',
        variant: 'kpi-reservations',
        title: STRINGS.totalReservations,
        icon: 'fa-calendar-check-o',
        value: formatNumber(data.totalReservations),
      },
      {
        key: 'visitors',
        variant: 'kpi-visitors',
        title: STRINGS.totalVisitors,
        icon: 'fa-users',
        value: formatNumber(data.totalVisitors),
      },
      {
        key: 'revenue',
        variant: 'kpi-revenue',
        title: STRINGS.totalRevenue,
        icon: 'fa-money',
        value: formatNumber(data.totalRevenue),
        suffix: STRINGS.currency,
      },
      {
        key: 'avgRev',
        variant: 'kpi-avg-rev',
        title: STRINGS.avgRevenue,
        icon: 'fa-calculator',
        value: formatNumber(data.avgRevenue),
        suffix: STRINGS.currency,
      },
    ];

    if (data.activatedBracelets > 0) {
      list.push({
        key: 'bracelets',
        variant: 'kpi-occupancy',
        title: STRINGS.activatedBracelets,
        icon: 'fa-id-badge',
        value: formatNumber(data.activatedBracelets),
      });
    }

    if (data.popularByVisitors) {
      list.push({
        key: 'popular',
        variant: 'kpi-popular',
        title: STRINGS.popularService,
        icon: 'fa-fire',
        value: data.popularByVisitors.name,
        footer: (
          <>
            <i className="fa fa-users" />{' '}
            {formatNumber(data.popularByVisitors.totalVisitors)} {STRINGS.visitors}
          </>
        ),
      });
    }

    return list;
  }, [data]);

  if (cards.length === 0) return null;

  return (
    <div className="kpis-grid">
      {cards.map((c) => (
        <KPICard
          key={c.key}
          variant={c.variant}
          title={c.title}
          icon={c.icon}
          value={c.value}
          suffix={c.suffix}
          footer={c.footer}
        />
      ))}
    </div>
  );
};

export default KPIGrid;
